function PrivacyPolicy({ onBack }) {
  const updated = 'April 24, 2026';

  return (
    <div className="legal">
      <div className="legal-inner">
        <button className="legal-back" onClick={onBack}>← Back to home</button>
        <span className="eyebrow">Legal</span>
        <h1>Privacy Policy</h1>
        <p className="legal-meta">Last updated: {updated}</p>

        <section>
          <h2>Introduction</h2>
          <p>
            AiToolsJournal ("we", "us", or "our") operates this website. This page
            explains what information we collect, how we use it, and the choices you
            have. By using the site, you agree to the practices described below.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <ul>
            <li><strong>Usage data:</strong> pages visited, referring URL, device type, and approximate location derived from IP address.</li>
            <li><strong>Newsletter:</strong> the email address you submit when subscribing.</li>
            <li><strong>Cookies:</strong> small files used to remember preferences and measure traffic.</li>
          </ul>
        </section>

        <section>
          <h2>Advertising and Google AdSense</h2>
          <p>
            We use Google AdSense to display advertisements. Google and its partners
            may use cookies and similar technologies to serve ads based on your prior
            visits to this and other websites. Google's use of advertising cookies
            enables it and its partners to serve ads to you.
          </p>
          <p>
            You can opt out of personalised advertising by visiting{' '}
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
              Google Ads Settings
            </a>
            , or learn more about how advertising cookies are used at{' '}
            <a href="https://www.aboutads.info" target="_blank" rel="noopener noreferrer">
              aboutads.info
            </a>.
          </p>
        </section>

        <section>
          <h2>Analytics</h2>
          <p>
            We may use privacy-respecting analytics tools to understand which content
            is most useful. These tools collect aggregated, non-identifying
            information about how visitors use the site.
          </p>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>Operate, maintain, and improve the website.</li>
            <li>Send the newsletter you subscribed to (you may unsubscribe at any time).</li>
            <li>Show relevant advertisements through Google AdSense.</li>
            <li>Detect and prevent abuse or fraud.</li>
          </ul>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>
            Depending on your location, you may have the right to access, correct, or
            delete the personal data we hold about you, and to object to or restrict
            certain processing. To exercise these rights, contact us using the email
            below.
          </p>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>
            This site is not directed at children under 13, and we do not knowingly
            collect personal information from children under 13.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this policy from time to time. Material changes will be
            reflected in the "Last updated" date at the top of this page.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Questions about this policy? Email us at{' '}
            <a href="mailto:hello@aitoolsjournal.example">hello@aitoolsjournal.example</a>.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
